import {
  DateRangeFacet,
  MultiMatchQuery,
  RangeFacet,
  RefinementSelectFacet
} from "@searchkit/sdk";
import {
  FacetsList,
  SearchBar,
  ResetSearchButton,
  SelectedFilters,
  Pagination
} from "@searchkit/elastic-ui";
import { useSearchkitVariables } from "@searchkit/client";
import { useSearchkitSDK } from "@searchkit/sdk/lib/esm/react-hooks";
import {
  EuiPage,
  EuiFlexGrid,
  EuiPageBody,
  EuiPageContent,
  EuiPageContentBody,
  EuiPageContentHeader,
  EuiPageContentHeaderSection,
  EuiPageHeader,
  EuiPageHeaderSection,
  EuiPageSideBar,
  EuiTitle,
  EuiHorizontalRule,
  EuiText,
  EuiFlexGroup,
  EuiFlexItem,
  EuiComboBox
} from "@elastic/eui";

import "@elastic/eui/dist/eui_theme_light.css";

const config = {
  host: 'https://search.bernardlonergan.com',
  index: "archive3",
  hits: {            // fields you want returned from the query. I think this is part of GraphQL
    fields: [        
      "boost^10",   //contains keyword terms: author, sku, language, decade, pdf, archivalnum
      "sku", 
      "page_number", // not searched
      "title^2",
      "pdf_page_title",
      "media_path",
      "media_type",
      "author", 
      "decade",
      "language", 
      "language1", 
      "language2", 
      "archivalnum", 
      "transcription", 
      "description",
      "content"
    ]
  },
  sortOptions: [
    { id: 'relevance', label: "Relevance", field: [{"_score": "desc"}], defaultOption: true}
  ],
  query: new MultiMatchQuery({ // fields you want to search upon
    fields: [
      "boost",  //contains keyword terms: author, sku, language, decade, pdf, archivalnum
      'sku',   
      'title', 
      'transcription',
      'description',
      'content'
    ]
  }),

  facets: [
      
    new RefinementSelectFacet({
      field: 'media_type',
      identifier: 'media_type',
      label: 'Media type',
      multipleSelect: true
    }),
        
    new RefinementSelectFacet({
      field: 'author',
      identifier: 'author',
      label: 'Author',
      multipleSelect: true
    }),
        
    new RefinementSelectFacet({
      field: 'decade',
      identifier: 'decade',
      label: 'Decade',
      multipleSelect: true
    }),
        
    new RefinementSelectFacet({
      field: 'language',
      identifier: 'language',
      label: 'Language',
      multipleSelect: true
    }),
        
  ]
};

const HitsList = ({ data }) => (
  <EuiFlexGrid>
    {data?.hits.items.map((hit) => (
      <EuiFlexItem key={hit.id}>
        <EuiFlexGroup gutterSize="xl">
          <EuiFlexItem>
            <EuiFlexGroup>
              
              <EuiFlexItem grow={4}>
                <EuiTitle size="xs">
                <h6> <a href={'/archive/' + hit.fields.sku.toLowerCase()}>{hit.fields.title}</a></h6>
                </EuiTitle>
                <EuiText grow={false}>
                  
                <p>{hit.fields.description.substring(0,750)}...</p>
                </EuiText>
              </EuiFlexItem>
              <EuiFlexItem grow={2}>
                <EuiText grow={false}>
                  <ul>
                    <li>
                      <b>AUTHOR: </b>
                      <p>{hit.fields.author}</p>
                    </li>

                    <li>
                      <b>LANGUAGE: </b>
                      <p>{hit.fields.language1}, {hit.fields.language2}</p>
                    </li>
                    <li>
                      <b>SKU: </b>
                      <p>{hit.fields.sku}</p>
                    </li>
                    <li>
                      <b>ARCHIVAL NUMBER: </b>
                      <p>{hit.fields.archivalnum}</p>
                    </li>
                  </ul>
                </EuiText>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    ))}
  </EuiFlexGrid>
);

function App() {
  const Facets = FacetsList([]);
  const variables = useSearchkitVariables();
  const { results, loading } = useSearchkitSDK(config, variables);
  console.log('173 App.js results =', results);
  return (
    <EuiPage>
      <EuiPageSideBar>
        <SearchBar loading={loading} />
        <EuiHorizontalRule margin="m" />
        <Facets data={results} loading={loading} />
      </EuiPageSideBar>
      <EuiPageBody component="div">
        <EuiPageHeader>

          <EuiPageHeaderSection>
            <ResetSearchButton loading={loading} />
          </EuiPageHeaderSection>
        </EuiPageHeader>
        <EuiPageContent>
          <EuiPageContentHeader>
            <EuiPageContentHeaderSection>
              <EuiTitle size="s">
                <h2>{results?.summary.total} Results</h2>
              </EuiTitle>
            </EuiPageContentHeaderSection>
          </EuiPageContentHeader>
          <EuiPageContentBody>
            <HitsList data={results} />
            <EuiFlexGroup justifyContent="spaceAround">
              <Pagination data={results} />
            </EuiFlexGroup>
          </EuiPageContentBody>
        </EuiPageContent>
      </EuiPageBody>
    </EuiPage>
  );
}

export default App;
